import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import DpiProductFields from "./DpiProductFields";

export default function EditDpiProduct() {
  const data = useLoaderData();
  const loadFn = (form) =>
    form.setFieldsValue({
      dpiId: data.dpi?.id,
      description: data.description,
      supplier: data.supplier,
      supplierCode: data.supplierCode,
      sku: data.sku,
      color: data.color,
      size: data.size,
    });

  return (
    <SimpleFormPage title="Modifica prodotto DPI" loadFn={loadFn}>
      <DpiProductFields />
    </SimpleFormPage>
  );
}
